var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H15.25C15.5982 4.5 15.8909 4.73723 15.9754 5.05887C15.6557 5.02 15.3302 5 15 5C13.5937 5 12.2722 5.36284 11.124 6H3.75C3.33579 6 3 5.66421 3 5.25Z",
    fill: "#B06724"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1905 18.5C8.76141 18.0469 8.38476 17.5437 8.07026 17H2.75C2.33579 17 2 17.3358 2 17.75C2 18.1642 2.33579 18.5 2.75 18.5H9.1905Z",
    fill: "#F7AE6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1404 14.5C7.23895 15.0195 7.38774 15.5213 7.58152 16H4.75C4.33579 16 4 15.6642 4 15.25C4 14.8358 4.33579 14.5 4.75 14.5H7.1404Z",
    fill: "#DE9552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C7 12.6613 7.02104 12.3276 7.06189 12H3.75C3.33579 12 3 12.3358 3 12.75C3 13.1642 3.33579 13.5 3.75 13.5H7.01537C7.00517 13.3346 7 13.1679 7 13Z",
    fill: "#D9904D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80423 9.5C7.57251 9.97552 7.38654 10.4774 7.25204 11H2.75C2.33579 11 2 10.6642 2 10.25C2 9.83579 2.33579 9.5 2.75 9.5H7.80423Z",
    fill: "#D28946"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38468 8.5C8.76215 7.94617 9.20734 7.4422 9.70835 7H4.75C4.33579 7 4 7.33579 4 7.75C4 8.16421 4.33579 8.5 4.75 8.5H8.38468Z",
    fill: "#C67D3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 20C18.866 20 22 16.866 22 13C22 9.13401 18.866 6 15 6C11.134 6 8 9.13401 8 13C8 16.866 11.134 20 15 20ZM14.4223 16.3661C14.4223 16.7162 14.7061 17 15.0562 17C15.4064 17 15.6902 16.7162 15.6902 16.3661V16.3007C16.7331 16.0676 17.5 15.2937 17.5 14.38C17.5 13.0093 16.3957 12.5897 15.2505 12.3007L15.1376 12.2705C14.4032 12.0744 13.9213 11.9457 13.9213 11.3776C13.9213 10.8928 14.4427 10.5944 15.0767 10.5944C15.6902 10.5944 16.2117 10.958 16.2117 11.4522H17.5C17.5 10.5571 16.7229 9.80186 15.6902 9.58741C15.6902 9.26299 15.4272 9 15.1028 9H15.0097C14.6853 9 14.4223 9.26299 14.4223 9.58741C13.3998 9.81119 12.6431 10.5478 12.6431 11.4429C12.6431 12.7823 13.8786 13.0904 14.7645 13.3113L14.862 13.3357C15.6493 13.5501 16.2117 13.7646 16.2117 14.38C16.2117 14.9207 15.6697 15.303 14.9949 15.303C14.32 15.303 13.7679 14.9207 13.7679 14.3893H12.5C12.5 15.3403 13.318 16.1329 14.4223 16.338V16.3661Z",
    fill: "#582D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/Accounting.48087b412f527e01c5ddb1e78750ff42.svg";
export { ForwardRef as ReactComponent };